import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AdminSettings.css";
import AdminNavbar from "./AdminNavbar";

function AdminSettings() {
    const [categories, setCategories] = useState([]);
    const [newCategory, setNewCategory] = useState("");
    const [newSubcategory, setNewSubcategory] = useState("");
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const res = await axios.get("https://himchatterjee.in/backend/categories.php");
            setCategories(Array.isArray(res.data) ? res.data : []);
        } catch (err) {
            console.error(err);
        }
    };

    const addCategory = async () => {
        if (!newCategory) return;
        await axios.post("https://himchatterjee.in/backend/add_category.php", { name: newCategory });
        setNewCategory("");
        fetchCategories();
    };

    const addSubcategory = async (catId) => {
        if (!newSubcategory) return;
        await axios.post("https://himchatterjee.in/backend/add_subcategory.php", { name: newSubcategory, category_id: catId });
        setNewSubcategory("");
        setSelectedCategoryId(null);
        fetchCategories();
    };

    const deleteCategory = async (id) => {
        if (window.confirm("Are you sure you want to delete this category?")) {
            await axios.post("https://himchatterjee.in/backend/delete_category.php", { id });
            fetchCategories();
        }
    };

    const deleteSubcategory = async (id) => {
        if (window.confirm("Are you sure you want to delete this subcategory?")) {
            await axios.post("https://himchatterjee.in/backend/delete_subcategory.php", { id });
            fetchCategories();
        }
    };

    return (
       <>
         <AdminNavbar />
       
        <div className="admin-settings">
           
            <h1>Admin Settings</h1>

            {/* Add Category */}
            <div className="add-category">
                <input
                    type="text"
                    value={newCategory}
                    onChange={(e) => setNewCategory(e.target.value)}
                    placeholder="Add new category..."
                />
                <button className="btn-add" onClick={addCategory}>Add Category</button>
            </div>

            {/* Categories List */}
            <div className="categories-container">
                {categories.map((cat) => (
                    <div key={cat.id} className="category-card">
                        <div className="category-header">
                            <h3>{cat.name}</h3>
                            <div className="category-actions">
                                <button className="btn-edit">Edit</button>
                                <button className="btn-delete" onClick={() => deleteCategory(cat.id)}>Delete</button>
                            </div>
                        </div>

                        {/* Subcategories */}
                        <ul className="subcategory-list">
                            {cat.subcategories.map((sub) => (
                                <li key={sub.id}>
                                    {sub.name}
                                    <div className="subcategory-actions">
                                        <button className="btn-edit">Edit</button>
                                        <button className="btn-delete" onClick={() => deleteSubcategory(sub.id)}>Delete</button>
                                    </div>
                                </li>
                            ))}
                        </ul>

                        {/* Add Subcategory */}
                        <div className="add-subcategory">
                            <input
                                type="text"
                                value={selectedCategoryId === cat.id ? newSubcategory : ""}
                                onFocus={() => setSelectedCategoryId(cat.id)}
                                onChange={(e) => setNewSubcategory(e.target.value)}
                                placeholder="Add new subcategory..."
                            />
                            <button className="btn-add" onClick={() => addSubcategory(cat.id)}>Add Subcategory</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
        </>
    );
}

export default AdminSettings;
